module.exports = __webpack_public_path__ + "static/media/icon-clip.bf493e6c.svg";